export default "__VITE_ASSET__ECwrau3o__"